import { createTheme } from '@mantine/core';

export default createTheme({
  fontFamily: 'Lexend, sans-serif',
});
